import React from 'react';
import { Button, Typography } from 'antd';
import BaseModal from 'components/modules/BaseModal';

type Props = {
    isOpen: boolean;
    onCancel: () => void;
    onSubmit: () => void;
};

const MfaBulkDisableModal: React.FC<Props> = ({
    isOpen,
    onCancel,
    onSubmit,
}) => {
    return (
        <BaseModal
            visible={isOpen}
            title='多要素認証設定を一括解除'
            footer={[
                <Button
                    key='cancel'
                    size='large'
                    onClick={onCancel}
                >
                    キャンセル
                </Button>,
                <Button
                    key='save'
                    size='large'
                    type='primary'
                    onClick={onSubmit}
                >
                    実行
                </Button>,
            ]}
            onCancel={onCancel}
            maskClosable={false}
            width={430}
        >
            <Typography.Paragraph>
                    選択したユーザーの多要素認証設定を一括で解除します。
                    <br/>
                    解除されたユーザーは、再度認証アプリの登録が必要になります。
            </Typography.Paragraph>
            <p>実行しますか？</p>
        </BaseModal>
    );
};

export default MfaBulkDisableModal;
